/*global angular*/
module.exports = [function () {
  'use strict';
  return {
    restrict: 'E',
    template: require('./imageGroup.html'),
    replace: true,
    transclude: true,
    scope: {
      content: '=data'
    },
    link: function (scope) {
      function isEven(n) {
        return n % 2 == 0;
      }

      function isOdd(n) {
        return Math.abs(n % 2) == 1;
      }
       scope.even = isEven(scope.content.contents.length);
    }
  };
}];




// WEBPACK FOOTER //
// ./web/js/module/visionText/js/imageGroup/imageGroup.js